'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _components = require('components');

var _glamor = require('glamor');

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

var _Button = require('@quixeltools/quixel-ui-library/dist/components/common/essentials/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noneFoundMessage = (0, _glamor.css)({
  display: 'block',
  color: _css.colors.gray,
  fontSize: '1rem',
  margin: 'auto',
  textAlign: 'center',
  fontWeight: '300',
  paddingLeft: (0, _css.unitRem)(0.7),
  paddingRight: (0, _css.unitRem)(0.7)
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  marginTop: '4em',
  fontSize: '0.9rem'
}));

var icon = (0, _glamor.css)((0, _css.bgCover)('/icons/asset_not_found.png'), {
  width: (0, _css.unitRem)(4),
  height: (0, _css.unitRem)(4),
  display: 'inline-block'
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  width: (0, _css.unitRem)(2),
  height: (0, _css.unitRem)(2)
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  width: (0, _css.unitRem)(3),
  height: (0, _css.unitRem)(3)
}));

var boldText = (0, _glamor.css)({
  display: 'block',
  fontSize: (0, _css.unitRem)(1.3),
  paddingBottom: (0, _css.unitRem)(1),
  marginTop: (0, _css.unitRem)(1.5),
  fontWeight: '700',
  color: _css.colors.white
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  marginTop: (0, _css.unitRem)(1.5),
  fontSize: (0, _css.unitRem)(1)
}));

exports.default = function () {
  return _react2.default.createElement(
    _components.AppSideEffects,
    { documentTitle: 'Oops! Page not found!' },
    _react2.default.createElement(
      'section',
      null,
      _react2.default.createElement(_components.SiteHeaderGap, null),
      _react2.default.createElement(
        'div',
        { className: (0, _glamor.css)({ display: 'flex', justifyContent: 'center', width: '100%', height: '80vh' }) },
        _react2.default.createElement(
          'div',
          { className: noneFoundMessage },
          _react2.default.createElement('span', { className: icon }),
          _react2.default.createElement(
            'span',
            { className: boldText },
            'This page was unfortunately lost in the desert',
            _react2.default.createElement('br', null),
            'while scanning. We\u2019re so sorry!'
          ),
          _react2.default.createElement(_Button2.default, { mode: 'secondary', label: 'TAKE ME HOME', to: '/' })
        )
      )
    )
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/NotFound/NotFound.jsx
// module id = 1268
// module chunks = 0